import type { ReactElement } from 'react';
import { twMerge } from 'cn';
import { GroupIris } from './group-iris.jsx';
import type { ContentProps, StudioDescriptor } from '../../types.js';

/** Iris vendor `<Content>` component with flattened room list. */
export const ContentIris = ({
  className,
  data,
  handler,
  hasRegistryLoaded: _hasRegistryLoaded,
  isRegistryLoading: _isRegistryLoading,
  orgOnly: _orgOnly,
  selectedOrgId: _selectedOrgId,
  selectedRoomId: _selectedRoomId,
  selection,
  ...props
}: ContentProps): ReactElement => {
  // Data is already sorted correctly by toData() in data.ts:
  // 1. THIS DEVICE first
  // 2. OWNER studios before guest studios
  // 3. By creation date (newest first), fallback to alphabetical
  const allRooms = (data as StudioDescriptor[]) ?? [];

  // Get the first organization for the header
  const firstOrg = allRooms[0]?.organization;

  return (
    <div
      className={twMerge(
        '[&>div[role="menuitem"]]:text-md',
        'w-[100%] overflow-y-auto rounded-8',
        className
      )}
      style={{ maxHeight: '55vh' }}
      {...props}
    >
      {/* Single Studios Header with all rooms */}
      {!!handler.onSelectRoom && firstOrg && (
        <GroupIris
          handler={handler}
          organization={firstOrg}
          rooms={allRooms}
          selection={selection}
        />
      )}
    </div>
  );
};
